import { useVehicleDashboardContext } from "./useVehicleDashboardContext";
import { VehiclePreparationType } from "../../../../types/vehicle.type";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";


const PreparationItem = ({ item, label }) => (
  <div className="bg-white/40 mb-1 py-1 rounded">
    {item ? (
      <div className="flex gap-2 items-center text-greenPrimary m-2">
        <ImCheckboxChecked />
        <h2 className="text-black dark:text-black font-medium">{label}</h2>
      </div>
    ) : (
      <div className="flex gap-2 items-center text-gray3 m-2 font-semibold">
        <ImCheckboxUnchecked />
        <h2 className="text-black dark:text-black font-medium">{label}</h2>
      </div>
    )}
  </div>
);

function PreparationInfo() {
  const { vehicle } = useVehicleDashboardContext();
  const vehiclePreparing: VehiclePreparationType = vehicle.vehiclePreparing;

  return (
    <>
      <h1 className="text-2xl font-semibold mb-4">Preparação</h1>
      <div className=" rounded-md bg-gray/20 text-black p-4 mb-2">
        <div className="rounded row-span-3 col-span-2 text-black dark:text-black">
          <div className="grid grid-cols-2 grid-rows-3 gap-2 text-sm">

            <PreparationItem item={vehiclePreparing?.paintingProtection} label="Proteção da pintura (PP)" />
            <PreparationItem item={vehiclePreparing?.tracker} label="Rastreador (RT)" />
            <PreparationItem item={vehiclePreparing?.cellphoneSupport} label="Suporte de celular (SC)" />
            <PreparationItem item={vehiclePreparing?.phoneChargerSupport} label="Carregador do celular (CC)" />
            <PreparationItem item={vehiclePreparing?.engineProtection} label="Proteção da carenagem (PC)" />
            <PreparationItem item={vehiclePreparing?.trackerValidation} label="Validação de rastreamento (VR)" />
            <PreparationItem item={vehiclePreparing?.crlvDocument} label="CRLV (CV)" />
            <PreparationItem item={vehiclePreparing?.nfDocument} label="Nota Fiscal (NF)" />
          </div>
        </div>
      </div>
    </>
  );
}
export default PreparationInfo;